export default __webpack_public_path__ + "static/media/vuesax-linear-task-square.4a3e6b45.svg";